"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_form_saga_1 = __importDefault(require("redux-form-saga"));
var effects_1 = require("redux-saga/effects");
var redux_saga_routines_1 = require("redux-saga-routines");
var feedSaga_js_1 = require("../util/feed/feedSaga.js");
var feedSaga_js_2 = require("../util/bountyFeed/feedSaga.js");
var userSaga_js_1 = require("../user/userSaga.js");
var articlesSaga_js_1 = require("../yourtrybe/articles/articlesSaga.js");
var postSaga_1 = require("../post/postSaga");
var EditorSaga_1 = require("../util/dashboard/EditorSaga");
var ImageAddSaga_1 = require("../util/articleEditor/imageAdd/ImageAddSaga");
var SocialFeedSaga_1 = require("../yourtrybe/social/SocialFeedSaga");
var FollowingSaga_1 = require("../yourtrybe/following/FollowingSaga");
var userReviewSaga_1 = require("../user-review/userReviewSaga");
var FriendsSaga_1 = require("../yourtrybe/friends/FriendsSaga");
var signUpSaga_1 = require("../sign-up/signUpSaga");
var settingsSaga_1 = require("../yourtrybe/settings/settingsSaga");
function root() {
    var allWatchers;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                allWatchers = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], settingsSaga_1.settingsWatchers, true), feedSaga_js_1.feedWatchers, true), feedSaga_js_2.bountyFeedWatchers, true), userSaga_js_1.userWatchers, true), postSaga_1.postWatchers, true), EditorSaga_1.editorWatchers, true), ImageAddSaga_1.uploadImageWatchers, true), articlesSaga_js_1.articlesWatchers, true), SocialFeedSaga_1.socialFeedWatchers, true), userReviewSaga_1.userReviewWatchers, true), FollowingSaga_1.followingWatchers, true), FriendsSaga_1.friendsWatchers, true), signUpSaga_1.signUpWatchers, true), [
                    redux_saga_routines_1.routinePromiseWatcherSaga,
                    redux_form_saga_1.default
                ], false);
                return [4 /*yield*/, (0, effects_1.all)(allWatchers.map(function (saga) { return (0, effects_1.fork)(saga); }))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.default = root;
